// Mock data for Armstrong Technologies clone (frontend-only)

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1654781393394-df3c9a66d0b5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  cctvSky: "/img/partnership.png",
  reliable: "/img/reliable.png",
  partnership: "/img/partnership.png",
  aircon: "/img/aircon.png",
  network: "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  security: "/img/security.png",
  av: "/img/av.png",
  electrical: "https://images.unsplash.com/photo-1593941707874-ef25b8b4a92b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  smart: "/img/smart.png",
  maintenance: "https://images.unsplash.com/photo-1604754742629-3e5728249d73?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services", hasDropdown: true },
  { label: "Industries", to: "/industries" },
  { label: "Process", to: "/process" },
  { label: "Contact", to: "/contact" },
];

export const SERVICES = [
  {
    slug: "network-it-infrastructure",
    icon: "Network",
    title: "Network & Infrastructure Services",
    short: "Structured, well-documented networks that give your business the speed, coverage, and reliability it depends on.",
    image: IMAGES.network,
    deliver:
      "We design and install structured cabling and network hardware for offices, warehouses, and multi-site operations. Every installation is tested, labelled, and documented so future changes are straightforward, and we can support the network long after handover.",
    bullets: [
      "Structured cabling",
      "Network installation and configuration",
      "Wi-Fi deployment",
      "Server room setup",
      "Network troubleshooting",
    ],
  },
  {
    slug: "security-systems",
    icon: "ShieldCheck",
    title: "Security Systems",
    short: "CCTV, access control, and intruder alarms specified around the real risks to your premises.",
    image: IMAGES.security,
    deliver:
      "We design and install CCTV, access control, and alarm systems specified around the real risks to your premises — properly integrated where it makes sense, and maintained to keep footage and access records dependable.",
    bullets: [
      "CCTV installation",
      "Access control systems",
      "Intruder alarms",
      "Video monitoring solutions",
      "Security system maintenance",
    ],
  },
  {
    slug: "audio-visual-solutions",
    icon: "MonitorPlay",
    title: "Audio Visual Solutions",
    short: "Meeting rooms, signage, and sound systems that work first time, every time.",
    image: IMAGES.av,
    deliver:
      "We install and configure AV that staff and visitors can use without training — displays, conferencing, signage, and sound. Cabling is concealed, sources are switched cleanly, and we hand over a system your team can actually operate.",
    bullets: [
      "Conference room technology",
      "Digital signage",
      "Sound systems",
      "Projector and display installation",
      "Video conferencing solutions",
    ],
  },
  {
    slug: "electrical-installations",
    icon: "Zap",
    title: "Electrical Installations",
    short: "Commercial electrical work, lighting, power distribution, and EV charge points.",
    image: IMAGES.electrical,
    deliver:
      "Our electrical work is completed to current standards, tested, and certified. That includes lighting schemes, distribution boards, and EV charge point installations — with fast and smart charging options that reduce running costs.",
    bullets: [
      "Commercial electrical work",
      "Lighting systems",
      "Power distribution",
      "EV — electric vehicle charge point installations — save money on fast / smart charging",
    ],
  },
  {
    slug: "smart-technology",
    icon: "Cpu",
    title: "Smart Technology",
    short: "Automation, media walls, and remote monitoring that make a property easier to run.",
    image: IMAGES.smart,
    deliver:
      "We integrate lighting, climate, media, and monitoring into one system that is simple to control from a panel or a phone. Installations are designed around how you use the space, not around a product catalogue.",
    bullets: [
      "Smart home installations",
      "Media walls",
      "Automation systems",
      "Smart lighting",
      "Climate control integration",
      "Remote monitoring solutions",
    ],
  },
  {
    slug: "maintenance-support",
    icon: "Wrench",
    title: "Maintenance & Support",
    short: "Planned maintenance, emergency repairs, and service contracts that keep systems running.",
    image: IMAGES.maintenance,
    deliver:
      "Systems only deliver value while they are working. We offer preventative maintenance visits, responsive callouts, upgrades, and service contracts scaled to the size of your estate.",
    bullets: [
      "Preventative maintenance",
      "Emergency repairs",
      "Technical support",
      "System upgrades",
      "Service contracts",
    ],
  },
  {
    slug: "eco-air-conditioning",
    icon: "Snowflake",
    title: "Eco-Friendly Air Conditioning",
    short: "Energy-efficient air conditioning and cooling solutions designed around comfort, savings, and sustainability.",
    image: IMAGES.aircon,
    deliver:
      "Creating an environmentally friendly and economical air conditioning system starts with smart design, modern technology, and professional ongoing maintenance. Every home and business has different heating and cooling requirements, so choosing the correct size and type of system is essential for maximum comfort, energy efficiency, and cost savings. We work with trusted, energy-efficient brands to deliver reliable solutions that reduce energy consumption without compromising performance \u2014 from selecting the right system to professional installation and ongoing servicing.",
    bullets: [
      "Correct system sizing and design",
      "Trusted, energy-efficient brands",
      "Professional installation",
      "Ongoing servicing and maintenance",
      "New installations and upgrades",
      "Lower energy bills and environmental impact",
    ],
  },
];

export const WHY_CHOOSE = [
  {
    icon: "BadgeCheck",
    title: "Experienced Professionals",
    text: "Our qualified technicians bring years of industry experience to every project.",
  },
  {
    icon: "ClipboardCheck",
    title: "Quality Assurance",
    text: "We use trusted products, proven installation methods, and rigorous testing procedures.",
  },
  {
    icon: "Timer",
    title: "Responsive Service",
    text: "Fast response times and dependable support when you need it most.",
  },
  {
    icon: "Share2",
    title: "Tailored Solutions",
    text: "Every project is designed around your specific operational and technical requirements.",
  },
  {
    icon: "ShieldAlert",
    title: "Safety & Compliance",
    text: "All work is completed in accordance with relevant industry standards and regulations.",
  },
];

export const INDUSTRIES = [
  { icon: "Building2", title: "Commercial Offices" },
  { icon: "Store", title: "Retail Stores" },
  { icon: "Warehouse", title: "Warehouses" },
  { icon: "Factory", title: "Industrial Facilities" },
  { icon: "GraduationCap", title: "Educational Institutions" },
  { icon: "HeartPulse", title: "Healthcare Facilities" },
  { icon: "UtensilsCrossed", title: "Hospitality Venues" },
  { icon: "Home", title: "Residential Properties" },
];

export const PROCESS = [
  { no: "01", title: "Consultation", text: "We assess your requirements and discuss the best solution for your project." },
  { no: "02", title: "Site Survey", text: "Our team evaluates the installation environment and technical specifications." },
  { no: "03", title: "Proposal & Planning", text: "You receive a detailed quotation and project plan." },
  { no: "04", title: "Installation", text: "Professional implementation with minimal disruption to your operations." },
  { no: "05", title: "Testing & Handover", text: "Comprehensive testing and client training ensure everything performs as expected." },
  { no: "06", title: "Ongoing Support", text: "Maintenance and support services keep your systems operating at peak performance." },
];

export const TESTIMONIALS = [
  { quote: "Professional team, excellent workmanship, and delivered the project on time. Highly recommended.", author: "Commercial client" },
  { quote: "From consultation to installation, the service was outstanding. The team communicated clearly throughout the project.", author: "Property manager" },
  { quote: "Reliable support and quality installations. We’ve used them for multiple projects and will continue to do so.", author: "Retail client" },
];

export const COMPANY = {
  name: "Armstrong Technologies",
  tagline: "Technical Solutions You Can Trust",
  email: "services@armstrongtechnologies.co.uk",
  phone: "01494 580724",
  location: "Amersham, United Kingdom",
  hours: [
    { day: "Monday – Friday", time: "8:00 AM – 6:00 PM" },
    { day: "Saturday", time: "9:00 AM – 1:00 PM" },
    { day: "Sunday", time: "Closed" },
  ],
};
